(function (angular, app) {
   "use strict";

   angular.module(app.modules.group.name)
      .controller(app.modules.group.routes.setup.controller, GroupSetupController);
      
   GroupSetupController.$inject = ["$scope" ,"ngDialog"
      , app.modules.group.services.groups
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.ui.services.alerts
      , app.modules.common.constants.themelist
   ];
   
   function GroupSetupController($scope, ngDialog
      , ggGroupSvc
      , ggFunctions
      , ggStorage
      , ggAlertSvc
      , ggThemes
   ){
      
      // Scope the Group
      $scope.Group = null;
      $scope.PopupAlert = new ggAlertSvc.popup;
      $scope.InlineAlert = new ggAlertSvc.inline;

      // Assign this to object. Who want's to work with this?
      var ctrl = this;

      $scope.Temp = {
         isLoaded : true
         , isAdvanced : false
         , themes: ggThemes
         , handicapTypes : app.modules.group.constants.handicapTypes
      }

      $scope.f = {
         toggleAdvanced: function () {
            $scope.Temp.isAdvanced = !$scope.Temp.isAdvanced
         }
         , myGroups: function () {
            ggFunctions.goToPage(app.modules.group.routes.lookup.path)
         }
      }


      $scope.Content = {
         setup: {
            isDirty : false
            , form : {
               groupName : ""
               , groupId : 0
               , isPrivate : false
               , groupTypeId : 1 // 1, 2 --- Group, Club
               , isActive: true // 1, 2, 3 -- Active, Inactive, Archived
               , themeId: "1"
               , handicapType : "Official"
               , isUserHandicapUpdateAllowed: false
               , isAdminRestricted : false
            }
            , save : function(isValid){
               // Make sure group is not already saved
               $scope.Content.setup.isDirty = true;
               if (isValid){
                  if ($scope.Content.setup.form.groupId == 0) {
                     // Save Group
                     ggFunctions.toggleProcessing(true);
                     ggGroupSvc.setup.insertGroup($scope.Content.setup.form).then(function (data) {
                        if (data) {
                           if (data.status == "201") {
                              // Save groupId to form.
                              $scope.Content.setup.form.groupId = data.data.id;
                              // My groups aren't current
                              ggStorage.set(ggStorage.keys.groups.my.isCurrent, false);
                              ggStorage.set(ggStorage.keys.groups.organizer.isCurrent, false);

                              // This should be auto trigger in API
                              return app.Member.Authenticate.RefreshToken().then(function () {
                                 var btn = new ggAlertSvc.button;
                                 btn.name = "Continue";
                                 btn.path = app.modules.group.routes.detail.path + "?groupId=" + $scope.Content.setup.form.groupId + "&isNew";
                                 $scope.PopupAlert.success("Group Created!", "The group has been created.  Tap continue to add members to the group and setup golf outings.", [btn]);
                              });
                           }
                        }
                     }, function (error) {
                        ggFunctions.toggleProcessing(false);
                        $scope.InlineAlert.fail("Error", "There was an error inserting the group.");
                     }).finally(function () {
                        ggFunctions.toggleProcessing(false);
                     });
                  }
               }
            }
         }
      }


   }
}(angular, app));

